// extracted by mini-css-extract-plugin
export default {"carousel__wrapper":"Xy","carousel__wrapper_on_sides":"Yy","arrows_wrapper":"Zy","arrows_wrapper_right":"az","arrows_wrapper_vertical":"bz","arrows_wrapper_on_sides":"cz","arrow_button":"ez","carousel_arrow_left":"fz","carousel_arrow_left_on_side":"gz","carousel_arrow_right_on_side":"hz","carousel_arrow":"iz","arrows_wrapper_rounded":"jz","carousel__fullWidth":"kz"};
    if(module.hot) {
      // 1714654886327
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  